var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"accent","large":_vm.large,"dark":"","id":("get-started-" + _vm.bionicmetricsId)},on:{"click":function($event){return _vm.goToRequestDemo()}}},[_vm._v(_vm._s(_vm.label))])}
var staticRenderFns = []

export { render, staticRenderFns }